import React from 'react';
import { BonusesSection } from '../components/BonusesSection';
import { CostSection } from '../components/CostSection';
import { CountdownSection } from '../components/CountdownSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Hero } from '../components/Hero';
import { IncludedSection } from '../components/IncludedSection';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { SiteFooter } from '../components/SiteFooter';
import { StickyCta } from '../components/StickyCta';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VolumesSection } from '../components/VolumesSection';
export function Landing() {
  return <div className="w-full bg-cream-100 font-sans text-forest-800" data-id="element-206" data-mp="m7lfn1s6of8f">
      <Hero data-id="element-207" data-mp="m7v42kxkyec0" />
      <main data-id="element-208" data-mp="m5h90c2wh24g">
        <ProblemSection data-id="element-209" data-mp="2a0n4fmvd2bh" />
        <IncludedSection data-id="element-210" data-mp="2aadi4bttbhp" />
        <VolumesSection data-id="element-211" data-mp="2atn8xrbotkn" />
        <BonusesSection data-id="element-212" data-mp="27xm70k6horz" />
        <CountdownSection data-id="element-213" data-mp="3tgl7xhmbze02" />
        <OfferSection data-id="element-214" data-mp="3tfa3dfl2a27w" />
        <GuaranteeSection data-id="element-215" data-mp="3tes1o3fmqvsl" />
        <TestimonialsSection data-id="element-216" data-mp="3tio6wr5gohgx" />
        <FaqSection data-id="element-217" data-mp="3pe85p36sly81" />
        <CostSection data-id="element-218" data-mp="3pfj6cu4xypux" />
        <FinalCtaSection data-id="element-219" data-mp="3pezy6553ffu3" />
      </main>
      <SiteFooter data-id="element-220" data-mp="3kfwtwmwxtdn6" />
      <StickyCta data-id="element-221" data-mp="3kgf0acdbd88t" />
    </div>;
}